import { render, staticRenderFns } from "./MainHeaderLogo.vue?vue&type=template&id=2a618552&"
import script from "./MainHeaderLogo.vue?vue&type=script&lang=js&"
export * from "./MainHeaderLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports